import { render, staticRenderFns } from "./DriversFieldGroupsEditForm.vue?vue&type=template&id=36f2180c&scoped=true&"
import script from "./DriversFieldGroupsEditForm.vue?vue&type=script&lang=js&"
export * from "./DriversFieldGroupsEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DriversFieldGroupsEditForm.vue?vue&type=style&index=0&id=36f2180c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f2180c",
  null
  
)

export default component.exports